import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import SVG from "images/Upsell/crown.svg?react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

export const BTIconUpsellCrown: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    return (
        // eslint-disable-next-line react/forbid-elements
        <Icon {...props} component={SVG} />
    );
};
